import React from 'react';
import { set, get } from 'lodash';
import { usePlanningBottomupState } from '../Context/index';
import { checkIsNumber } from '../../../Components/helper';
import { TerminalPath } from '../TablesFieldPath';
import useTerminalCalculationHooks from '../Hooks/useTerminalCalculationHooks';

export function Terminal() {
  const { planningBottomup, setPlanningBottomup, checkVisibleBottomUp } = usePlanningBottomupState();
  const { planningBottomProducts, selectedLevel, selectedDisplayColumn } = planningBottomup;
  const level = selectedLevel?.level;
  const { calculateTerminal } = useTerminalCalculationHooks();

  const terminalField = [
    {
      keyName: 'terminal',
      name: 'Terminal %',
    },
    {
      keyName: 'terminalUnits',
      name: 'Terminal Units',
    },
  ];

  const handleChange = async (text, path, index) => {
    const copyState = planningBottomProducts;
    set(copyState, path, text);
    const currObj = get(copyState, index);
    copyState[index] = await calculateTerminal(currObj, level);
    setPlanningBottomup((prevState) => ({
      ...prevState,
      planningBottomProducts: copyState,
    }));
  };
  const includeLevel = [6];

  const isTableVisible = terminalField.filter((ele) => selectedDisplayColumn?.includes(ele.keyName));

  return (
    isTableVisible.length > 0 && (
      <table className="table custom-table layout-fixed planning-actual-tbl font-13 mr-3">
        <thead>
          <tr>
            {terminalField.map((mdFielsItem, i) => {
              const isVisible = checkVisibleBottomUp(mdFielsItem.keyName);
              return (
                isVisible && (
                  <th key={i} className="w-200px">
                    <span>{mdFielsItem.name}</span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          {(planningBottomProducts ?? [])?.map((trItem, iParent) => {
            return (
              <tr key={iParent}>
                {terminalField?.map((tdItem, iTD) => {
                  const isVisible = checkVisibleBottomUp(tdItem.keyName);
                  return (
                    isVisible &&
                    (tdItem.keyName === 'terminal' ? (
                      <td key={iTD} className="text-right">
                        {level === 6 ? (
                          <div className="d-flex align-items-center">
                            <input
                              type="text"
                              className="form-control text-bordered"
                              value={trItem[tdItem?.keyName].value}
                              onChange={(e) => {
                                if (checkIsNumber(e.target.value)) {
                                  handleChange(e.target.value, TerminalPath(iParent, tdItem?.keyName).TERMINAL_KEYS, iParent);
                                }
                              }}
                              disabled={!includeLevel.includes(level) || !planningBottomup?.addEditBottomAccess}
                            />
                            <span className="ml-1">%</span>
                          </div>
                        ) : (
                          isVisible && `${trItem[tdItem?.keyName].value || 0}%`
                        )}
                      </td>
                    ) : (
                      <td key={iTD} className="text-right">
                        {trItem?.terminalUnits}
                      </td>
                    ))
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    )
  );
}
export default Terminal;
